import { useState } from "react";
import { Nav } from "react-bootstrap";
import { QuestionCircle, ArrowRepeat } from "react-bootstrap-icons";
import { WithApiAccess } from "../../lib/HigherOrderComponents/WithApiAccess";

function UserGuideInner({ api, collapsed }) {
  const [loading, setLoading] = useState(false);

  const handleClick = (event) => {
    event.preventDefault();
    if (loading || !api) return;
    setLoading(true);

    const newTab = window.open("", "_blank");

    api
      .getBlob(`/api/documentation/userguide`)
      .then((response) => {
        if (response.status !== 200) {
          newTab?.close();
          return;
        }

        const file = new Blob([response.data], { type: "application/pdf" });
        const blobUrl = window.URL.createObjectURL(file);

        if (newTab) {
          newTab.location.href = blobUrl;
        }

        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 10000);
      })
      .catch((err) => {
        console.error("[UserGuide] Failed to load PDF:", err);
        newTab?.close();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Nav.Item as="li">
      <a
        href="#user-guide"
        onClick={handleClick}
        className={
          "cp-nav-item nav-link" + (loading ? " cp-nav-item--loading" : "")
        }
        title={collapsed ? "User Guide" : undefined}
        aria-disabled={loading}
      >
        <span className="cp-nav-item__icon">
          {loading ? (
            <ArrowRepeat className="cp-nav-item__spinner" />
          ) : (
            <QuestionCircle />
          )}
        </span>
        {!collapsed && <span className="cp-nav-item__label">User Guide</span>}
      </a>
    </Nav.Item>
  );
}

export const UserGuide = WithApiAccess(UserGuideInner);
